import { baseShadowStyle } from '@shared/style/base-shadow';
import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Controls = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
    height: fit-content;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s opacity;
`;

export const ProductInfo = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 15px 19px;
    gap: 8px;
    border-radius: 20px;
    border: 1px solid ${COLORS.neutral_05};
    background: ${COLORS.neutral_00};
    ${baseShadowStyle}

    &:hover ${Controls} {
        visibility: visible;
        opacity: 1;
    }

    &:hover ${ProductInfo} {
        & > :last-child {
            color: ${COLORS.primary_60};
        }
    }
`;

export const Header = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const Content = styled('div')`
    display: flex;
    gap: 24px;
`;

export const InfoGroup = styled('div')<{ $maxWidth?: number }>(({ $maxWidth }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    maxWidth: $maxWidth ? `${$maxWidth}px` : 'unset',
}));
